import { v4 as uuid } from 'uuid';
export const getCorrelationId = id => {
  const defaultCorrelationId = `${Date.now()}-${uuid()}`;
  return id !== null && id !== void 0 ? id : defaultCorrelationId;
};